
import Component from "vue-class-component";
import Vue from "vue";
import BarcodeManufacturerModule  from "@/store/modules/barcodeSystem/barcodeManufacturer";
import { getModule } from "vuex-module-decorators";
import Select from "@/components/form/Select.vue";
import { ManufacturerResource, ManufacturerListItem } from "../../models/api/barcodeSystem/barcodeManufacturers/get";
import { EditBarcodeManufacturerModel } from "@/models/ui/editBarcodeManufacturer";
import { formatBool } from "@/utils";

const barcodeManufacturerModuleState = getModule(BarcodeManufacturerModule);
import notifications from "../../lib/notifications";
@Component({
  components: {
    Select
  }
})
export default class BarcodeManufacturers extends Vue {
  manufacturers: ManufacturerListItem[] = null;
  manufacturerFilter: string = null;
  loading: boolean = false;
  editManufacturerModel: EditBarcodeManufacturerModel = null;
  promptDelete: boolean = false;
  asnOptions = [
    { text: 'Standard', value: 'standard', disabled: false },
    { text: 'Stock', value: 'stock', disabled: false },
    { text: 'None', value: 'none', disabled: false }
  ]

  async created() {
    await this.loadManufacturers();
  }

  async loadManufacturers() {
    this.loading = true;
    await barcodeManufacturerModuleState.loadManufacturers();
    this.manufacturers = barcodeManufacturerModuleState.manufacturers;
    this.loading = false;
  }

  get filteredManufacturers() {
    if(this.manufacturerFilter)
      return this.manufacturers.filter(x =>(x.manufacturerName && x.manufacturerName.toUpperCase().startsWith(this.manufacturerFilter.toUpperCase()) ||
                                           x.code.toUpperCase().startsWith(this.manufacturerFilter.toUpperCase())));
    else
      return this.manufacturers;
  }

  formatBool(val: string)
  {
    return formatBool(val);
  }

  manufacturerNameState() {
    return this.editManufacturerModel.manufacturerName ? null : false;
  }

  codeState() {
    return this.editManufacturerModel.code ? null : false;
  }

  validateForm() {
    if(this.manufacturerNameState() === false) return false;
    if(this.codeState() === false) return false;
    return true;
  }

  goBack() {
    this.$router.back();
  }

  async saveManufacturer() {
    if(!this.validateForm()) return;
    try {
      this.editManufacturerModel.saving = true;
      if (this.editManufacturerModel.isNew) {
        await barcodeManufacturerModuleState.createManufacturer(this.editManufacturerModel.toCreateManufacturerRequest());
      } else {
        await barcodeManufacturerModuleState.updateManufacturer(this.editManufacturerModel.toUpdateManufacturerRequest());
      }
      notifications.success("Manufacturer Saved", "Successfully saved manufacturer");
      await this.loadManufacturers();
      this.closeEditManufacturerModal();
    } catch (ex) {
      notifications.error("Save Manufacturer", "Failed to save manufacturer", ex);
      this.editManufacturerModel.saving = false;
    }
  }

  async deleteManufacturer() {
    try {
      this.editManufacturerModel.saving = true;
      if (!this.editManufacturerModel.isNew) {
        await barcodeManufacturerModuleState.deleteManufacturer(this.editManufacturerModel.code);
      }
      notifications.success("Manufacturer Deleted", "Successfully deleted manufacturer");
      await this.loadManufacturers();
      this.closeEditManufacturerModal();
    } catch (ex) {
      notifications.error("Delete Manufacturer", "Failed to delete manufacturer", ex);
      this.editManufacturerModel.saving = false;
    }
  }

  promptForDelete() {
    this.promptDelete = true;
  }

  closeDeleteModal() {
    this.promptDelete = false;
  }

  closeEditManufacturerModal() {
    this.promptDelete = false;
    this.editManufacturerModel.visible = false;
    this.editManufacturerModel = null;
  }

  async editManufacturer(item: ManufacturerListItem = null) {
    this.editManufacturerModel = new EditBarcodeManufacturerModel();
    this.editManufacturerModel.visible = true;

    if (item) {
      const manufacturer = await barcodeManufacturerModuleState.getManufacturer(item.code);
      this.editManufacturerModel.loading = false;
      this.editManufacturerModel.isNew = false;
      this.$set(this.editManufacturerModel, 'code', manufacturer.code);
      this.$set(this.editManufacturerModel, 'manufacturerName', manufacturer.manufacturerName);
      this.$set(this.editManufacturerModel, 'suppliesAsn', manufacturer.suppliesAsn);
      this.$set(this.editManufacturerModel, 'pickingEnabled', manufacturer.pickingEnabled);
      this.$set(this.editManufacturerModel, 'suppliesStockAsn', manufacturer.suppliesStockAsn);
      this.$set(this.editManufacturerModel, 'excludeFromScanningCompliance', manufacturer.excludeFromScanningCompliance);
      this.$set(this.editManufacturerModel, 'allowManualStockOrdersCreation', !!manufacturer.allowManualStockOrdersCreation);
    } else {
      this.editManufacturerModel.showForNewManufacturer();
    }
  }
}
